"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { AnimatePresence, motion, easeInOut } from "framer-motion";
import IconCart from "../icons/icon-cart";
import IconMenu from "../icons/icon-menu";
import IconClose from "../icons/icon-close";
import { useCart } from "@/lib/cart/useCart";

const links = [
  { name: "Menu", href: "/menu" },
  { name: "About", href: "/about" },
  { name: "Gallery", href: "/gallery" },
  { name: "Blogs", href: "/blogs" },
];

const dropdownVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.35,
      ease: easeInOut,
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.25,
      ease: easeInOut,
    },
  },
};

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { lines } = useCart();

  const allSelected = lines.length > 0 && lines.every((l) => l.selected);
  return (
    <header className="w-full fixed top-[41px] sm:top-[51px] left-0 z-[100] px-5 center max-sm:justify-end max-sm:items-end">
      <div className="max-w-[196.64px] sm:max-w-[659.72px] w-full sm:mx-auto px-[25px] py-[7px] bg-[#0A0A0A]/25 rounded-[22px] sm:rounded-lg backdrop-blur-[25px] border border-white/[57%]">
        <div className="w-full flex items-center justify-between gap-[30px]">
          {/* Logo */}
          <Link
            href="/"
            className="w-[36.74px] sm:w-[50.72px] h-[41.15px] sm:h-[56.81px] shrink-0"
          >
            <Image
              src={"/imgs/logo.png"}
              alt="al-majlish-logo"
              width={50.72}
              height={56.81}
              className="w-full h-full object-contain"
            />
          </Link>

          {/* Nav links desktop */}
          <div className="flex-1">
            <ul className="flex items-center justify-center gap-[30px]">
              {links.map((link, index) => (
                <li key={index} className="sm:block hidden">
                  <Link href={link.href} className="text-white uppercase">
                    {link.name}
                  </Link>
                </li>
              ))}
              <li className="relative">
                <Link href="/cart">
                  <IconCart />
                </Link>
                <div className="size-[13.95px] bg-old-gold rounded-full absolute top-[-30%] right-[-30%] center text-[10.47px] font-medium">
                  {lines.length}
                </div>
              </li>
            </ul>
          </div>

          {/* Desktop CTA */}
          <button className="sm:block hidden shrink-0 max-w-[135px] w-full btn_gradient relative isolate">
            <span className="text-xs uppercase">
              <Link href={"https://wa.me/8801830000233"}> Book a Table</Link>
            </span>
            <div className="size-full absolute inset-0 bg-gradient-to-b from-[#FFFFFF]/[7%] to-[#FFFFFF]/15 z-[-2]"></div>
          </button>

          {/* Mobile Menu Toggle */}
          <button
            className="sm:hidden block"
            onClick={() => setIsNavOpen(!isNavOpen)}
          >
            {isNavOpen ? <IconClose /> : <IconMenu />}
          </button>
        </div>

        {/* Mobile dropdown with animation */}
        <AnimatePresence>
          {isNavOpen && (
            <motion.div
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={dropdownVariants}
              className="sm:hidden block overflow-hidden"
            >
              <ul className="center flex-col py-3.5 my-3.5 gap-6 border-y border-white/[50%]">
                {links.map((link, index) => (
                  <li key={index}>
                    <Link
                      href={link.href}
                      className="text-sm text-white uppercase"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <button className="shrink-0 max-w-[149px] w-full btn_gradient relative isolate mb-3">
                <span className="text-xs uppercase">Book A Table</span>
                <div className="size-full absolute inset-0 bg-gradient-to-b from-[#FFFFFF]/[7%] to-[#FFFFFF]/15 z-[-2]"></div>
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;

// "use client";

// import Image from "next/image";
// import Link from "next/link";
// import React, { useState } from "react";
// import IconCart from "../icons/icon-cart";
// import IconMenu from "../icons/icon-menu";
// import IconClose from "../icons/icon-close";

// const links = [
//   {
//     name: "Menu",
//     href: "/menu",
//   },
//   {
//     name: "About",
//     href: "/about",
//   },
//   {
//     name: "Specials",
//     href: "/services",
//   },
// ];

// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);

//   return (
//     <header className="w-full fixed top-[41px] sm:top-[70px] left-0 z-[100] px-5 center max-sm:justify-end max-sm:items-end">
//       <div className="max-w-[196.64px] sm:max-w-[659.72px] w-full sm:mx-auto px-[25px] py-[7px] bg-[#0A0A0A]/25 rounded-[22px] sm:rounded-lg backdrop-blur-[25px] border border-white/[57%]">
//         <div className="w-full flex items-center justify-between gap-[30px]">
//           <Link
//             href="/"
//             className="w-[36.74px] sm:w-[50.72px] h-[41.15px] sm:h-[56.81px] shrink-0"
//           >
//             <Image
//               src={"/imgs/logo.png"}
//               alt="al-majlish-logo"
//               width={50.72}
//               height={56.81}
//               className="w-full h-full object-contain"
//             />
//           </Link>
//           <div className="flex-1">
//             <ul className="flex items-center justify-center gap-[30px]">
//               {links.map((link, index) => (
//                 <li key={index} className="sm:block hidden">
//                   <Link href={link.href} className="text-white uppercase">
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//               <li className="relative">
//                 <IconCart />
//                 <div className="size-[13.95px] bg-old-gold rounded-full absolute top-[-30%] right-[-30%] center text-[10.47px] font-medium">
//                   2
//                 </div>
//               </li>
//             </ul>
//           </div>
//           <button className="sm:block hidden shrink-0 max-w-[135px] w-full btn_gradient relative isolate">
//             <span className="text-xs uppercase">Book A Table</span>
//             <div className="size-full absolute inset-0 bg-gradient-to-b from-[#FFFFFF]/[7%] to-[#FFFFFF]/15 z-[-2]"></div>
//           </button>
//           <button
//             className="sm:hidden block"
//             onClick={() => setIsNavOpen(!isNavOpen)}
//           >
//             {isNavOpen ? <IconClose /> : <IconMenu />}
//           </button>
//         </div>

//         {/* dropdown */}
//         {isNavOpen && (
//           <div className="sm:hidden block">
//             <ul className="center flex-col py-3.5 my-3.5 gap-6 border-y border-white/[50%]">
//               {links.map((link, index) => (
//                 <li key={index} className="">
//                   <Link
//                     href={link.href}
//                     className="text-sm text-white uppercase"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//             <button className="shrink-0 max-w-[149px] w-full btn_gradient relative isolate">
//               <span className="text-xs uppercase">Book A Table</span>
//               <div className="size-full absolute inset-0 bg-gradient-to-b from-[#FFFFFF]/[7%] to-[#FFFFFF]/15 z-[-2]"></div>
//             </button>
//           </div>
//         )}
//       </div>
//     </header>
//   );
// };

// export default Header;
